import { useMutation, useQueryClient } from '@tanstack/react-query';
import request from 'utils/request';
import { EVENTS_CUSTOM_FIELDS_KEY } from './useEventCustomFieldDefinitions';

function updateSchoolEventCustomField(
  schoolyearId: string,
  schoolId: string,
  customFieldId: string,
  body: {
    targets: string[];
  },
) {
  return request(
    `/schoolyears/${schoolyearId}/schools/${schoolId}/school-events-custom-fields/${customFieldId}`,
    {
      method: 'PATCH',
      body,
    },
  );
}

export const useUpdateSchoolEventCustomFieldDefinition = ({
  schoolyearId,
  schoolId,
}: {
  schoolyearId: string;
  schoolId: string;
}) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({
      customFieldId,
      body,
    }: {
      customFieldId: string;
      body: { targets: string[] };
    }) =>
      updateSchoolEventCustomField(schoolyearId, schoolId, customFieldId, body),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [EVENTS_CUSTOM_FIELDS_KEY],
      });
    },
  });
};
